import React, { useEffect, useRef, useState } from "react";

import GMapsComponent from "../../components/maps/gMaps";

const Locate = () => {
  const [showMapsAutoComplete, setShowMapsAutoComplete]: any = useState(false);

  const [defaultAutoCompleteVal, setDefaultAutoCompleteVal]: any =
    useState(null);
  const refGMap = useRef(null);
  const [storeData, setStoreData]: any = useState([]);
  const [newStoreData, setNewStoreData]: any = useState({
    latitude: "",
    longitude: "",
    stl_category_id: "",
    distance: 5,
  });
  const [stores, setStores] = useState([]);
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    const input: any = refGMap.current;
    if (input) {
      input.value = defaultAutoCompleteVal;
    }
  }, [defaultAutoCompleteVal]);

  useEffect(() => {
    const json = {
      ...newStoreData,
      latitude: "",
      longitude: "",
    };
    setNewStoreData({ ...json });
  }, []);
  const [mapCenter, setMapCenter] = useState({});

  const renderMapsAutoComplete = () => {
    setShowMapsAutoComplete(true);
  };
  return (
    <>
      <GMapsComponent
        storeData={storeData}
        setStoreDataFromMap={setStoreData}
        setStores={setStores}
        renderMapsAutoComplete={renderMapsAutoComplete}
        mapCenter={mapCenter}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
      />
    </>
  );
};

export default Locate;
